#import "../fragments/account-type-fragment.graphql"

query GetAccountTypes {
    accountTypes {
        ...AccountType
    }
}
